import {
	type DetailedHTMLProps,
	type HTMLAttributes,
	useEffect,
	useState,
} from 'react'
import { cn } from '#app/utils/misc.js'

export default function Image({
	src,
	alt,
	...props
}: {
	alt: string
	src: string
} & DetailedHTMLProps<HTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
	const [isLoading, setLoading] = useState(true)

	useEffect(() => {
		setTimeout(() => {
			if (!isLoading) return
			setLoading(false)
		}, 1500)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div
			{...props}
			className={cn(
				'relative aspect-square w-full overflow-hidden bg-gray-200',
				props.className,
			)}
		>
			<img
				draggable={false}
				alt={alt}
				onLoad={() => setLoading(false)}
				src={src}
				className={cn(
					'h-full w-full duration-700 ease-in-out',
					isLoading
						? 'scale-110 blur-2xl grayscale'
						: 'scale-100 blur-0 grayscale-0',
				)}
				sizes="100vw"
				style={{
					objectFit: 'cover',
					objectPosition: 'center',
				}}
			/>
		</div>
	)
}

export function PlainImage({
	src,
	alt,
	...props
}: {
	alt: string
	src: string
} & DetailedHTMLProps<HTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
	return (
		<div
			{...props}
			className={cn(
				'relative aspect-square w-full overflow-hidden bg-gray-200',
				props.className,
			)}
		>
			<img
				draggable={false}
				alt={alt}
				src={src}
				className={cn('h-full w-full duration-700 ease-in-out')}
				sizes="100vw"
				style={{
					objectFit: 'cover',
					objectPosition: 'center',
				}}
			/>
		</div>
	)
}
